/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-danger */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-var */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Calendar } from 'react-date-range';
import moment from 'utils/moment';
import styles from './Scheduling.module.scss';
import Button from '../../../components/button/button';
import PulpoField from '../../../pulpo_visualizer/fields';
import { isLocal, hostName } from '../../../constants/apiEnv';
import FormSubmitted from '../../forms/components/FormSubmitted';
import Loading from '../../../components/loading';
import CustomFields from '../../../components/customFields/CustomFields';
import { GetFileName, S3Uploads } from '../../services';

const getAdjustedDate = (data) => {
  const disableSameDay = data?.calender?.settings?.disable_same_day_scheduling === false;

  let selectedDate = new Date();

  // If same-day is NOT allowed → move to tomorrow
  if (disableSameDay) {
    selectedDate.setDate(selectedDate.getDate() + 1);
  }

  selectedDate.setHours(0, 0, 0, 0);

  if (data) {
    const weekAvailabilityInfo = data?.calender?.settings?.week_availablity_info || {};
    const blockedDetails = (data?.calender?.settings?.blocked_details || [])
      .filter(d => !d?.start_time)
      .map(d => moment(d.block_date).format('DD/MM/YYYY'));

    const weekUnavailabilityDays = Object.keys(weekAvailabilityInfo)
      .filter(day => (weekAvailabilityInfo[day] || []).length === 0);

    while (
      weekUnavailabilityDays.includes(moment(selectedDate).format('ddd').toUpperCase())
      || blockedDetails.includes(moment(selectedDate).format('DD/MM/YYYY'))
    ) {
      selectedDate.setDate(selectedDate.getDate() + 1);
    }
  }

  return selectedDate;
};

const Scheduling = (props) => {
  const initialState = {
    selected_date: null,
    selected_time_slot: '',
    useCalendarData: {},
    available_time_slots: [],
    person_details: {},
    dataError: false,
    useDisableDates: []
  };
  const [showNext, setShowNext] = useState(false);
  const [stepForm, setStepForm] = useState(1);
  const [fieldErrors, handleFieldError] = useState({
    phone: true,
    email: true,
    first_name: true,
    last_name: true,
    useFieldError: false
  });
  const [schedule_data, handleScheduleData] = useState(initialState);
  const [info, setInfo] = useState({});
  const [schema_fields, setSchema_fields] = useState([]);
  const [requiredMap, setRequiredMap] = useState({});
  const [custom_fieldErrors, setCustom_fieldErrors] = useState({});
  const [conditionalFields, setConditionalFields] = useState({});
  const [showFormErrors, setShowFormErrors] = useState(false);
  const [apiSuccessMsg, handleApiStatus] = useState({ apiSuccessMessage: '', apiSuccess: false, loading: false });
  const [blockedDate, setBlockedDate] = useState([]);
  const [startTimeInMinutes, setStartTimeInMinutes] = useState([]);
  const [endTimeInMinutes, setEndTimeInMinutes]= useState([]);
  // DESTRUCTURE STATE
  const { selected_time_slot, useCalendarData, airportData, available_time_slots, person_details,
    utcSlotStartDate, utcSlotEndDate, useDisableDates } = schedule_data;

  const { match: { params: { id, airportCode } }, applicationData, Reschedule, onRescheduleSuccess, onClose } = props;
  const url = hostName.slice(6);
  const installationId = localStorage.getItem('installationId') || 'us';
  const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${installationId}${url}/public`;

  useEffect(() => {
  (async () => {
    if (Reschedule) {
      const appData = applicationData;
      const startDate = new Date(appData.start_ts);

      const formatTime = (d) => {
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      };

      const timeSlot = formatTime(startDate);
      const selectedDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        0, 0, 0, 0
      );

      // Get full slots for that date
      const realCal = appData.calender;
      const realAirport = appData.airport;
      const { settings } = realCal || {};
      const { week_availablity_info, schedule_duration } = settings || {};

      const weekDay = moment(selectedDate).format('ddd').toUpperCase();
      const useAvailablityList = week_availablity_info?.[weekDay] || [];
      const slotDuration = schedule_duration === '1' ? 60 : Number(schedule_duration);
      let getSlots = [];

      useAvailablityList.forEach((eachT) => {
        const takeSlot = createTimeSlots(eachT?.from?.value, eachT?.to?.value, slotDuration);
        getSlots = [...getSlots, ...takeSlot];
      });

      // Sort the slots chronologically
      const sortedSlots = getSlots
        .map(t => new Date(`1970-01-01T${t}`))
        .sort((a, b) => a - b)
        .map(t => t.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }));

      // Ensure selected time is part of the list, then sort again
      const allSlots = [...new Set([...sortedSlots, timeSlot])].sort(
        (a, b) => new Date(`1970-01-01T${a}`) - new Date(`1970-01-01T${b}`)
      );

      // Prefill schedule data from application
      handleScheduleData(prev => ({
        ...prev,
        ...appData,
        selected_date: selectedDate,
        selected_time_slot: timeSlot,
        available_time_slots: [timeSlot], // keep this for now — we will replace it after fetching calendar
        useDisableDates: [],
        person_details: {
          first_name: appData.first_name,
          last_name: appData.last_name,
          phone: appData.phone,
          email: appData.email
        },
        dataError: false
      }));
      setInfo(appData.form_answer || {});
      try {
        const resp = await fetch(`${publicUrl}/scheduling/booking/${airportCode}/badging`);
        const fetched = await resp.json();
        const realCal = fetched?.calender || appData?.calender; // fallback
        const realAirport = fetched?.airport || appData?.airport || {};

        if (realCal?.schema?.fields?.length > 0) {
          const fields = realCal.schema.fields;
          let requiredMap = {};
          let conditionalFieldsInfo = {};
          let schemaFieldErrors = {};

          fields.forEach((detailField) => {
            if (
              detailField.type !== 'dataSource'
              && detailField.type !== 'dataSourceMultiselect'
              && detailField.type !== 'dataSourceMultiLevel'
              && detailField.type !== 'page_break'
              && detailField.type !== 'header'
              && detailField.type !== 'attachments'
            ) {
              requiredMap = { ...requiredMap, [detailField.id]: detailField.required };
              if (detailField.conditional) {
                if (conditionalFieldsInfo[detailField.conditional_field.key]) {
                  conditionalFieldsInfo[detailField.conditional_field.key] = [
                    ...conditionalFieldsInfo[detailField.conditional_field.key],
                    detailField
                  ];
                } else {
                  conditionalFieldsInfo[detailField.conditional_field.key] = [detailField];
                }
              } else if (detailField.required) {
                const val = appData?.form_answer?.[detailField.id];
                const hasValue = val !== undefined && val !== null && String(val).trim() !== '';
                schemaFieldErrors = { ...schemaFieldErrors, [detailField.id]: !hasValue };
              }
            }
          });

          setSchema_fields(fields);
          setRequiredMap(requiredMap);
          setCustom_fieldErrors(schemaFieldErrors);
          setConditionalFields(conditionalFieldsInfo);
        }


        // put calendar & airport into state so handleDateChange can use them
        handleScheduleData(prev => ({
          ...prev,
          useCalendarData: realCal,
          airportData: realAirport
        }));

        // now generate the full available slots for the selected date
        await handleDateChange(realCal, realAirport, selectedDate, false);

        // ensure the originally selected slot remains present and selected
        handleScheduleData((prev) => {
          const slots = Array.isArray(prev.available_time_slots) ? [...prev.available_time_slots] : [];
          if (!slots.includes(timeSlot)) slots.unshift(timeSlot);
          return {
            ...prev,
            available_time_slots: [...new Set(slots)],
            selected_time_slot: timeSlot
          };
        });
      } catch (err) {
        const message = 'There was a problem while retrieving the form';
        handleApiStatus({ apiSuccessMessage: message });
      }
    } else {
      // existing initial-load branch (unchanged)
      try {
        handleApiStatus({ ...apiSuccessMsg, loading: true });
        fetch(`${publicUrl}/scheduling/booking/${airportCode}/badging`)
          .then(response => response.json())
          .then((data) => {
            const tomorrowDate = getAdjustedDate(data);
            let conditionalFieldsInfo = {};
            let schemaFieldErrors = {};
            tomorrowDate.setHours(0, 0, 0, 0);
            if (data?.calender) {
              const fields = data?.calender?.schema?.fields || [];
              let requiredMap = {};
              fields.forEach((detailField) => {
                if (detailField.type !== 'dataSource' && detailField.type !== 'dataSourceMultiselect' && detailField.type !== 'dataSourceMultiLevel' && detailField.type !== 'page_break' && detailField.type !== 'header' && detailField.type !== 'attachments') {
                  requiredMap = { ...requiredMap, [detailField.id]: detailField.required };
                  if (detailField.conditional) {
                    if (conditionalFieldsInfo[detailField.conditional_field.key]) {
                      conditionalFieldsInfo[detailField?.conditional_field?.key] = [...conditionalFieldsInfo[detailField?.conditional_field?.key], detailField];
                    } else {
                      conditionalFieldsInfo[detailField?.conditional_field?.key] = [detailField];
                    }
                  } else if (detailField.required) {
                    const infoValue = info?.[detailField.id];
                    const appValue = applicationData?.form_answer?.[detailField.id];
                    // Prefer info value, fallback to application data
                    const value = infoValue ?? appValue;

                    const hasValue = value !== undefined && value !== null && String(value).trim() !== '';

                    schemaFieldErrors = {
                      ...schemaFieldErrors,
                      [detailField.id]: !hasValue
                    };
                  }
                }
                if (detailField?.type === 'string' && detailField?.id && detailField?.default_text && !info[detailField?.id]) {
                  setInfo(prevInfo => ({
                    ...prevInfo,
                    [detailField?.id]: detailField?.default_text
                  }));
                  schemaFieldErrors[detailField?.id] = false;
                }
              });
              setSchema_fields(fields);
              setRequiredMap(requiredMap);
              setCustom_fieldErrors(schemaFieldErrors);
              setConditionalFields(conditionalFieldsInfo);
              handleScheduleData(prev => ({
                ...prev,
                selected_date: tomorrowDate
              }));
              handleDateChange(data?.calender, data.airport, tomorrowDate, true);
            }
            if (data.calender) {
              const parsedBlockedDate = data?.calender?.settings?.blocked_details?.map(ele => !ele.start_time && ele.block_date) || [];
              setBlockedDate(parsedBlockedDate);
            }
          });
      } catch (error) {
        const message = 'There was a problem while retrieving the form';
        handleApiStatus({ apiSuccessMessage: message });
      }
    }
  })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleGetBookingByDate = async (startDate, endDate, slotsList) => {
    try {
      const response = await fetch(`${publicUrl}/scheduling/list_bookings/${airportCode}/badging?start=${startDate}&end=${endDate}`);
      const data = await response.json();

      let finalSlots = [...slotsList];
      data.forEach((eachVal) => {
        const slotTime = moment(eachVal.start_ts).format('HH:mm');
        finalSlots = finalSlots.filter(slot => slotTime !== slot);
      });

      return finalSlots;
    } catch (error) {
      const message = 'There was a problem while retrieving the form';
      handleApiStatus({ apiSuccessMessage: message, error: true });
      throw error; // rethrow the error to indicate that an error occurred
    }
  };


  const createTimeSlots = (fromTime, toTime, slotDuration) => {
    let startTime = moment(fromTime, 'HH:mm');
    const endTime = moment(toTime, 'HH:mm');
    const slotList = [];
    while (startTime.isSame(endTime) || startTime.isBefore(endTime)) {
      if (slotDuration === undefined || Number.isNaN(slotDuration)) {
        break;
      }
        const endTimeCheck = moment(toTime, 'HH:mm').subtract(slotDuration, 'minute');

      if (startTime.isSame(endTimeCheck) || startTime.isBefore(endTimeCheck)) {
        slotList.push(startTime.format('HH:mm'));
      }
        startTime = startTime.add(slotDuration, 'minute');
    }
    return slotList;
  };

  function getDayIndex(weekday) {
    const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    return weekdays.indexOf(weekday);
  }

  const handleGetAvailbleDates = (weekday, selectedMonth) => {
    const today = new Date(selectedMonth);
    const currentMonth = today.getMonth();
    const dates = [];
    const targetDay = getDayIndex(weekday);
    // Set the date to the first day of the current month
    today.setDate(1);
    while (today.getMonth() === currentMonth) {
      if (today.getDay() === targetDay) {
        // If the current day is the target day, add it to the array
        dates.push(new Date(today));
      }
      today.setDate(today.getDate() + 1);
    }
    return dates;
  };

  const handleNavigate = (dateRange) => {
    const useDisableDates = handleCalenderDates(useCalendarData?.settings?.week_availablity_info, dateRange);
    handleScheduleData({ ...schedule_data,
      useDisableDates
    });
  };

  const handleDateChange = async (useCalendarData, airportData, date, getLoading) => {
    if (getLoading) handleApiStatus({ ...apiSuccessMsg, loading: true });

    // Day range for bookings API
    let start = new Date(date);
    let end = new Date(date);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    const startISO = start.toISOString();
    const endISO = end.toISOString();

    // Build available slots
    const weekDay = moment(date).format('ddd').toUpperCase();
    const weekInfo = useCalendarData?.settings?.week_availablity_info || {};
    const dayAvailability = weekInfo[weekDay] || [];

    const slotDuration = useCalendarData?.settings?.schedule_duration === '1'
      ? 60
      : Number(useCalendarData?.settings?.schedule_duration);

    let slots = [];
    dayAvailability.forEach((eachT) => {
      const list = createTimeSlots(
        eachT?.from?.value,
        eachT?.to?.value,
        slotDuration
      );
      slots = [...slots, ...list];
    });

    // sort slots
    const sortedSlots = [...new Set(slots)]
      .map(t => new Date(`1970-01-01T${t}`))
      .sort((a, b) => a - b)
      .map(t => t.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }));

    // Remove already booked slots
    let finalSlots = await handleGetBookingByDate(
      startISO,
      endISO,
      sortedSlots
    );

    // REMOVE past slots if selected date is TODAY
    const now = moment();
    const selectedDay = moment(date);
    const allowSameDay = useCalendarData?.settings?.disable_same_day_scheduling ?? false;

    if (allowSameDay && selectedDay.isSame(now, 'day')) {
      finalSlots = finalSlots.filter((time) => {
        const slotMoment = moment(
          `${selectedDay.format('YYYY-MM-DD')} ${time}`,
          'YYYY-MM-DD HH:mm'
        );

        return slotMoment.isAfter(now);
      });
    }


    // Disabled calendar dates
    const useDisableDates = handleCalenderDates(weekInfo, date);

    // TIME DISABLE LOGIC
    const blockedDetails = useCalendarData?.settings?.blocked_details || [];
    const disable48 = useCalendarData?.settings?.disable_within_48_hours === true;
    handledisableTime(date, blockedDetails, disable48);
    // Update state
    handleScheduleData(prev => ({
      ...prev,
      selected_date: date,
      available_time_slots: finalSlots,
      selected_time_slot: '',
      dataError: false,
      useCalendarData,
      airportData,
      useDisableDates,
      person_details: {}
    }));

    handleApiStatus({ ...apiSuccessMsg, loading: false });
  };
  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };
  const convert12to24= (time12h) => {
      const [time, modifier] = time12h.split(' ');
      let [hours, minutes] = time.split(':');
      if (hours === '12') {
          hours = '00';
      }
      if (modifier === 'PM') {
          hours = parseInt(hours, 10) + 12;
      }
      return `${hours}:${minutes}`;
  };

  const handledisableTime = (date, blockTimes = [], disableWithin48hrs) => {
    const dayStart = moment(date).startOf('day');
    const dayEnd = moment(date).endOf('day');
    const selectedDateStr = dayStart.format('YYYY-MM-DD');

    let ranges = [];

    // Blocked specific times
    blockTimes.forEach((time) => {
      if (!time.start_time || !time.block_date) return;

      const blockDate = time.block_date.split('T')[0];
      if (blockDate !== selectedDateStr) return;

      const start = time.start_time.label.includes('AM') || time.start_time.label.includes('PM')
        ? convert12to24(time.start_time.label)
        : time.start_time.label;

      const end = time.end_time.label.includes('AM') || time.end_time.label.includes('PM')
        ? convert12to24(time.end_time.label)
        : time.end_time.label;

      ranges.push([timeToMinutes(start), timeToMinutes(end)]);
    });
    // TRUE 48-HOUR RESTRICTION (NO isBetween)
    if (disableWithin48hrs) {
      const now = moment();
      const cutoff = now.clone().add(48, 'hours');

      // Entire day is before cutoff → fully disabled
      if (dayEnd.isSameOrBefore(cutoff)) {
        ranges = [[0, 1440]];

      // Cutoff falls during this day → partial disable
      } else if (
        cutoff.isAfter(dayStart)
        && cutoff.isBefore(dayEnd)
      ) {
        const mins = cutoff.diff(dayStart, 'minutes');
        ranges.push([0, mins]);
      }
    }

    // Sort ranges
    ranges.sort((a, b) => a[0] - b[0]);
    const startArray = ranges.map(r => r[0]);
    const endArray = ranges.map(r => r[1]);
    setStartTimeInMinutes(startArray);
    setEndTimeInMinutes(endArray);
  };
  const handleCalenderDates = (week_info, currentMonth) => {
    let unavaialbleDates = [];
    week_info && Object.keys(week_info).forEach((eachWeek) => {
      if (week_info[eachWeek]?.length === 0) {
        unavaialbleDates = [...unavaialbleDates, ...handleGetAvailbleDates(eachWeek, currentMonth)];
      }
    });
    return unavaialbleDates;
  };
  const handleNextPage = () => {
    if (selected_time_slot) {
      if (stepForm !== 1) {
        const noErrors = fieldErrors && Object.keys(fieldErrors)?.every(k => fieldErrors[k] === false);
        if (noErrors) {
          setStepForm(stepForm + 1);
          setShowNext(true);
          handleScheduleData({ ...schedule_data, dataError: false });
        } else {
          handleFieldError({
            ...fieldErrors,
            useFieldError: true
          });
        }
      } else {
        // Prefill `person_details` from `applicationData`
        const prefilledData = {
          ...schedule_data,
          dataError: false,
          person_details: {
            first_name: applicationData?.first_name || '',
            last_name: applicationData?.last_name || '',
            phone: applicationData?.phone || '',
            email: applicationData?.email || ''
          }
        };

        setStepForm(stepForm + 1);
        setShowNext(!(schema_fields?.length > 0));
        handleScheduleData(prefilledData);
        // Reset fieldErrors for prefilled fields
        handleFieldError({
          first_name: !applicationData?.first_name,
          last_name: !applicationData?.last_name,
          phone: !applicationData?.phone,
          email: !applicationData?.email,
          useFieldError: false
        });
      }
    } else {
      handleScheduleData({ ...schedule_data, dataError: true });
    }
  };


  const handleBackPage = () => {
    setShowNext(false);
    setStepForm(stepForm - 1);
    handleFieldError({
      ...fieldErrors,
      useFieldError: false
    });
  };

  const handleAnswerChanged = (fieldId, value) => {
    handleScheduleData({
      ...schedule_data,
      person_details: {
        ...schedule_data.person_details,
        [fieldId]: value
      }
  });
  };

  const handleFieldErrorChanged = (a, b) => {
    handleFieldError({
      ...fieldErrors,
      [a]: b,
      useFieldError: false
    });
  };
  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id) {
        oldAttachments.push(e.attachment_id);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length, airportCode);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'scheduling'
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };
  const getFileNames = async (count, code) => {
    const response = await GetFileName.getPublicUploadFileName(count, code, 'scheduling');
    return response;
  };

  const doS3Upload = async (files, fileIds, entity) => {
    // eslint-disable-next-line prefer-const
    let response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      id,
      airportCode
    );
    return response;
  };

  const handleSaveUpload = async () => {
    let phone = person_details.phone;
    phone = phone[0] + phone.slice(1).replace(/[^\d]/g, '');
    let payload = {
      ...person_details,
      form_answer: info,
      start_ts: utcSlotStartDate,
      end_ts: utcSlotEndDate,
      phone
    };
    const attachmentFields = schema_fields.filter(schemaField => (
      schemaField?.type === 'attachments'
      ));

    let noErrors = fieldErrors && Object.keys(fieldErrors)?.every(k => (fieldErrors[k] === false));
    let customErrors = custom_fieldErrors && Object.keys(custom_fieldErrors)?.every(k => (custom_fieldErrors[k] === false));
    if (noErrors && customErrors) {
      if (attachmentFields.length > 0) {
        handleApiStatus({ ...apiSuccessMsg, loading: true });
        for (let index=0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && payload?.form_answer?.[attachmentField]?.length > 0) {
          payload.form_answer[attachmentField] = await handleUploadAttachments(payload?.form_answer[attachmentField], 'scheduling');
          }
        }
      }
      try {
        handleApiStatus({ ...apiSuccessMsg, loading: true });
        // Clean up invalid "id" values like "us"
        // check if `id` exists → use update API
        const apiUrl = Reschedule
        ? `${publicUrl}/scheduling/booking/${airportCode}/badging/${applicationData?.id}/`
        : `${publicUrl}/scheduling/booking/${airportCode}/badging`;
        const methodType = Reschedule ? 'PATCH' : 'POST'; // use PUT for update, POST for create
        const response = await fetch(apiUrl, {
          method: methodType,
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json' }
        });
          const res = await response.json();
          const updatedItem = res.data;
          if (Reschedule && onRescheduleSuccess) {
            onRescheduleSuccess(updatedItem); // pass updated schedule data
          }
          if (onClose) onClose();
          handleApiStatus({
          apiSuccessMessage: Reschedule
            ? 'Your schedule has been updated successfully.'
            : 'Your schedule is saved. Admin will contact you.',
          apiSuccess: true
        });
      } catch (error) {
        handleApiStatus({ apiSuccessMessage: 'There was a problem while retrieving the form' });
      }
    } else if (!customErrors) {
        setShowFormErrors(true);
      } else if (!noErrors) {
        handleFieldError({
          ...fieldErrors,
          useFieldError: true
        });
      }
  };

  const convertToLink = (text) => {
    var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=|!:,.;]*[-A-Z0-9+&@#\/%=|])/ig;
    var text1 = text?.replace(exp, "<a href='$1' target='_blank'>$1</a>");
    var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    return text1?.replace(exp2, '$1<a  href="http://$2" target="_blank">$2</a>');
  };

  const handleSelectSlot = (value) => {
    addTimeToSelectedDate(value);
  };

  const addTimeToSelectedDate = (timeToAdd) => {
    // Clone the selected date to avoid modifying the original date object
    const newDate = new Date(schedule_data?.selected_date);

    // Extract hours and minutes from the timeToAdd string
    const [hours, minutes] = timeToAdd.split(':');

    // Add hours and minutes to the date
    newDate.setHours(newDate.getHours() + parseInt(hours, 10));
    newDate.setMinutes(newDate.getMinutes() + parseInt(minutes, 10));

    // Update the state with the new date
    const slot_duration = useCalendarData?.settings?.schedule_duration === '1' ? 60 : Number(useCalendarData?.settings?.schedule_duration);
    handleScheduleData({ ...schedule_data,
      selected_time_slot: timeToAdd,
      utcSlotStartDate: moment(newDate).format(),
      utcSlotEndDate: moment(newDate).add(slot_duration, 'minutes').format() });
  };
  const blockDate = blockedDate.map(ele => new Date(moment(ele)));
  const useDates =[...useDisableDates, ...blockDate];

  const handleAnswerChangedFields = (answer, fieldId) => {
    if (conditionalFields?.[fieldId]) {
      conditionalFields[fieldId].forEach((item) => {
      const conditionValues = item?.conditional_values;
      let fieldValue = answer;
      let enabelCondition = false;
      if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
      enabelCondition = conditionValues.some(value => fieldValue === value?.value);
      if (item.required) {
      handleFieldErrorChangedFields(item.id, enabelCondition ? ![info]?.[item?.id] : false);
      }
      if (item?.type !== 'header') {
        if (enabelCondition) {
        setInfo(prevInfo => ({
          ...prevInfo,
          [fieldId]: answer,
          [item.id]: prevInfo?.[info]?.[item.id] || (item?.type === 'boolean' ? false : '')
        }));
      } else {
        setInfo(prevInfo => ({
          ...prevInfo,
          [fieldId]: answer,
          [item.id]: item?.type === 'boolean' ? false : ''
        }));
      }
    }
    if (item?.conditional) handleAnswerChanged('', item.id);
    });
  }
    setInfo({
      ...info,
      [fieldId]: answer
    });
  };

  const handleFieldErrorChangedFields = (a, b) => {
    setCustom_fieldErrors(prevInfo => ({
      ...prevInfo,
      [a]: b
    }));
  };
  const formatDisplayTime = (time) => {
    if (!time) return '';

    const is12HourFormat = airportData?.time_format === '12';

    const formatted = new Date(`1970-01-01T${time}`).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: is12HourFormat
    });
    return is12HourFormat
    ? formatted.replace(/am|pm/i, match => match.toUpperCase())
    : formatted;
  };
  return (
    <>
      <Loading loadingStatus={apiSuccessMsg?.loading} />
      {!apiSuccessMsg?.apiSuccess && (
        <div className={styles.Container}>
          <div className={styles.Container1}>
            <div className={styles.Container2}>
              <div className={styles.box}>
                <div className={styles.aeroStyle}>
                  <div className={styles.box1}>
                    <img className={styles.imgstyle} src={airportData?.logo} alt="Aerosimple" />
                  </div>
                  <hr />
                  <div className={styles.box3}>
                    <div style={{ color: '#7C869B', marginLeft: '25px', fontSize: '12px' }}>
                      <FormattedMessage id={airportData?.name || '-'} defaultMessage={airportData?.name} />
                    </div>
                    <div className={styles.aeroStyle2}>
                      <FormattedMessage id={useCalendarData?.title || '-'} defaultMessage={useCalendarData?.title} />
                    </div>
                    <div style={{ color: '#7C869B', margin: '10px 0 0 25px' }}>
                      <img className={styles.imgstyle1} src="https://cdn-icons-png.flaticon.com/128/1827/1827463.png" alt="Aerosimple" />
                      <span>
                        {useCalendarData?.settings?.schedule_duration}
                        {' Min '}
                      </span>
                    </div>
                    <div className={styles.information}>
                      <div dangerouslySetInnerHTML={{ __html: convertToLink(schedule_data?.useCalendarData?.settings?.Information) }} />
                    </div>
                  </div>
                </div>
                {stepForm === 1 && (
                  <>
                    <div>
                      <div className={styles.title}>
                        <FormattedMessage id="scheduling.title" defaultMessage="Select date & time" />
                      </div>
                      <div className={styles.CalendarStyle}>
                        <Calendar
                          date={schedule_data?.selected_date || new Date(0)}
                          dateFormat="yyyy-MM-DD"
                          onChange={e => handleDateChange(useCalendarData, airportData, e, true)}
                          color="#3A61A8"
                          disabledDay={(current) => {
                            const currentDate = moment(current);
                            const now = moment();

                            const disableSameDay = useCalendarData?.settings?.disable_same_day_scheduling ?? false;
                            const disable48 = useCalendarData?.settings?.disable_within_48_hours === true;

                            // Disable today if same-day NOT allowed
                            if (!disableSameDay && currentDate.isSame(now, 'day')) {
                              return true;
                            }

                            // 48-hour logic
                            if (disable48) {
                              const cutoff = now.clone().add(48, 'hours');

                              const isPastDay = currentDate.isBefore(now, 'day');
                              const isWithin48 = currentDate.isBefore(cutoff, 'day');
                              const isCutoffDay = currentDate.isSame(cutoff, 'day');

                              if ((isPastDay || isWithin48) && !isCutoffDay) return true;
                            }

                            return (
                              useDisableDates.includes(currentDate.format('YYYY-MM-DD'))
                              || currentDate.isBefore(now, 'day')
                            );
                          }}
                          disabledDates={useDates}
                          style={{ fontSize: '0.9rem' }}
                          onShownDateChange={handleNavigate}
                        />
                      </div>
                    </div>
                    <div className={styles.thirdbox}>
                      <p className={styles.thirdbox1}>
                        {moment(schedule_data?.selected_date).format('dddd, MMMM D')}
                      </p>
                        <div className={styles.useTimeSty}>
                          {[...available_time_slots]
                              .sort((a, b) => timeToMinutes(a) - timeToMinutes(b)) // ensures chronological order
                              .map((time) => {
                                const timeInMinutes = timeToMinutes(time);
                                let disabled = false;
                                for (let i = 0; i < startTimeInMinutes.length; i++) {
                                  const startTime = startTimeInMinutes[i];
                                  const endTime = endTimeInMinutes[i];
                                  if (timeInMinutes >= startTime && timeInMinutes <= endTime) {
                                    disabled = true;
                                    break;
                                  }
                                }
                                return (
                                  <div
                                    key={time}
                                    className={`${styles.smallBox} ${selected_time_slot === time ? styles.activeSlat : ''}`}
                                    onClick={() => !disabled && handleSelectSlot(time)}
                                    onKeyPress={() => !disabled && handleSelectSlot(time)}
                                    role="button"
                                    tabIndex={0}
                                    style={{
                                      cursor: disabled ? 'not-allowed' : 'pointer',
                                      borderColor: disabled ? 'gray' : '#3a61a8'
                                    }}
                                  >
                                    <span style={{ color: disabled && 'gray' }}>{formatDisplayTime(time)}</span>
                                  </div>
                                );
                              })}
                        </div>
                    </div>
                  </>)}
                {stepForm === 2 && !schedule_data?.dataError && (
                    <div>
                      <div className={styles.boxes}>
                        <div className={`${styles.scheduleBack}`}>
                        <div
                          className={styles.link}
                          role="link"
                          tabIndex={0}
                          onClick={() => handleBackPage()}
                          onKeyPress={() => handleBackPage()}
                        >
                          <FormattedMessage
                           id={'workorder.settings.back'}
                           defaultMessage={'Back'} />
                        </div>
                        </div>
                      </div>
                      <div className={styles.content1}>
                        <span>
                          {moment(schedule_data?.selected_date).format('dddd, MMMM D')}{' '}
                          {formatDisplayTime(selected_time_slot)}
                        </span>
                        &nbsp;
                        <span style={{ color: '#3A61A8', cursor: 'pointer' }}
                          onClick={() => handleBackPage()} onKeyPress={() => handleBackPage()} role="button" tabIndex={0}
                        >
                          <FormattedMessage id="scheduling.change" defaultMessage="Change" />
                        </span>
                      </div>
                      <div className={styles.Emailsfield}>
                        <PulpoField
                          key="first_name"
                          id="first_name"
                          type="string"
                          translationID="noise_log.public.name"
                          title="First Name"
                          isRequired
                          handleValueChange={(a, b) => handleAnswerChanged(b, a)}
                          answer={person_details.first_name}
                          showFieldErrors={fieldErrors.useFieldError}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                        />
                        <PulpoField
                          key="last_name"
                          id="last_name"
                          type="string"
                          translationID="portal.user.last_name"
                          title="Last Name"
                          isRequired
                          handleValueChange={(a, b) => handleAnswerChanged(b, a)}
                          answer={person_details.last_name}
                          showFieldErrors={fieldErrors.useFieldError}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                        />
                        <PulpoField
                          key="phone"
                          id="phone"
                          type="telephone"
                          translationID="hazard.phone"
                          title="Phone" isRequired
                          handleValueChange={(a, b) => handleAnswerChanged(b, a)}
                          answer={person_details.phone}
                          showFieldErrors={fieldErrors.useFieldError}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                        />
                        <PulpoField
                          key="email"
                          id="email"
                          type="string"
                          title="Email"
                          translationID="forms.complete.email"
                          className={styles.fullInput1}
                          handleValueChange={(a, b) => handleAnswerChanged(b, a)}
                          answer={person_details.email}
                          showFieldErrors={fieldErrors.useFieldError}
                          handleFieldErrorChanged={handleFieldErrorChanged}
                          isRequired
                        />
                      </div>
                    </div>
                )}
                {stepForm === 3 && schema_fields?.length > 0 && !schedule_data?.dataError
              &&<div className={`${styles.Emailsfield} ${styles.custom_Styles}`}>
                  <CustomFields
                    handleAnswerChanged={handleAnswerChangedFields}
                    handleFieldErrorChanged={handleFieldErrorChangedFields}
                    showFormErrors={showFormErrors}
                    requiredMap={requiredMap}
                    errorsList={[]}
                    placeHolders={[]}
                    fields={schema_fields || []}
                    answers={info}
                  />
                </div>
                }
              </div>
              <hr className={styles.hrtag} />
              <div className={styles.btnstyle}>
                <div style={{ marginRight: '16rem' }}>
                  {schedule_data?.dataError ? <span style={{ color: 'red', textAlign: 'center' }}>Please select your time slot</span> : '' }
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  {stepForm !== 1
                  &&<div>
                    <Button
                      action="tertiary"
                      onClick={() => handleBackPage()}
                      translationID="hazard.new.back"
                      defaultText="Back"
                      />
                    </div>}
                  {!showNext ? <div style={{ justifyContent: 'right', display: 'flex', width: '100%' }}>
                    <Button
                      action="secondary"
                      onClick={() => handleNextPage()}
                      translationID="filters.form.clear1"
                      defaultText="Next"
                    />
                               </div>
                  :!schedule_data?.dataError && (
                    <div>
                    <Button
                      className={styles.saveBtn}
                      onClick={() => handleSaveUpload()}
                      translationID="todo.newTask.save1"
                      defaultText="Submit" action="secondary"
                    />
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>)}

        {apiSuccessMsg?.apiSuccess && (
        <div className="container">
          <FormSubmitted name={airportData?.name}
            message={apiSuccessMsg?.apiSuccessMessage}
            logo={airportData?.logo}
            successMessage={useCalendarData?.settings?.success_message}
          />
        </div>
        )}
    </>
  );
};
export default withRouter(Scheduling);
